<template>

  <div id="app">
    <main>
      <div class="stripes">
        <div class="stripe s1"></div>
        <div class="stripe s2"></div>
        <div class="stripe s3"></div>
      </div>
    </main>
    <transition name="router-animation" enter-active-class="animated fadeInUp">
      <router-view/>
    </transition>
  </div>
</template>

<script>

import 'animate.css/animate.css'

export default {
  name: 'app'
}

</script>  

<style>

#app {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

main {
  position: relative;
  display: block;
  z-index: -1;
}

.stripes {
  position: absolute;
  width: 100%;
  transform: skewY(-12deg);
  height: 950px;
  top: -350px;
  background: linear-gradient(180deg, #e6ebf1 350px, rgba(230, 235, 241, 0));
}

.stripes .stripe {
  position: absolute;
  height: 190px;
}


.stripes .s1 {
  height: 541px;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(90deg, #14578c, rgba(230, 235, 241, 0));
}

.stripes .s2 {
  top: 549px;
  left: 4%;
  width: 96%;
  background: linear-gradient( 90deg, hsl(203, 7%, 78%), hsla(0, 0%, 100%, 0) );
}

.stripes .s3 {
  top: 748px;
  right: 0;
  width: 85%;
  background: linear-gradient(90deg, #80abc9, rgba(228, 233, 240, 0));
}


</style>
